import React, { PureComponent } from 'react';
import styled from 'styled-components';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import RedArrowIcon from '../../../../containers/assets/red-arrow.png'

const CourseLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
`;

const CourseLink = styled.div`
  width: 100%;
  max-width: 600px;
  height: 52px;
  background: #ffffff;
  display: flex;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  img {
    margin-left: 4px;
    width: 24px;
    height: 24px;
    position: relative;
    top: -1px;
  }
`;

class CareerPathwayStep2 extends PureComponent {
  render() {
    const { courses } = this.props;

    return (
      <Wrapper>
        <PreTitle>Leadership Pathway</PreTitle>
        <Title>Cultivating Leadership & Teamwork Skills</Title>
        <Text>
          <p>To further nurture your career ready skills, you should consider taking anyone of the following courses offered at your program.</p>
        </Text>
        <CourseLinks>
          {courses.map((course, index) => (
            <CourseLink key={index}>
              <div>{course.name}</div>
              <div>
                {course.code}
                <a href={course.url} rel="noreferrer" target="_blank">
                  <img src={RedArrowIcon} alt="red arrow icon" />
                </a>
              </div>
            </CourseLink>
          ))}
        </CourseLinks>
        <Text>
          <p>To learn more about career pathways and opportunities, we highly recommend that you reach out to your career center.</p>
        </Text>
      </Wrapper>
    );
  }

}

export default CareerPathwayStep2;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/career-pathway/step2.js